import { BehaviorSubject } from 'rxjs';
import { MessageEvent } from '@ui-kit/components/message';

type MessageFunction = (content: string, onClose?: () => void) => void;

export interface IMessage {
  onMessage: BehaviorSubject<MessageEvent | undefined>;
  success: MessageFunction;
  error: MessageFunction;
  warning: MessageFunction;
}

export default class Message implements IMessage {
  onMessage = new BehaviorSubject<MessageEvent | undefined>(undefined);
  DURATION = 30000;

  success(content: string, onClose?: () => void) {
    this.show({ type: 'success', content, onClose });
  }

  error(content: string, onClose?: () => void) {
    this.show({ type: 'error', content, onClose });
  }

  warning(content: string, onClose?: () => void) {
    this.show({ type: 'warning', content, onClose });
  }

  show(event: MessageEvent) {
    this.onMessage.next(event);
  }
}
